import { render, staticRenderFns } from "./Cardicon.vue?vue&type=template&id=97fbc6b2&"
import script from "./Cardicon.vue?vue&type=script&lang=js&"
export * from "./Cardicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports